import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ArticleAttachmentModalButton} from "./ArticleAttachmentModalButton";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const ArticleAttachment: React.FC<IProps> = (props) => {
    return props.article.attachments.length > 0 ? (
        <div className={articleAttachment}>
            <Text variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul className={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} className={downloadItem}>
                            <ArticleAttachmentModalButton attachmentId={id} attachmentLink={file} title={title} />
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css({
    p: 4,
    borderRadius: 2,
    mb: 2,
    backgroundColor: "white"
});

const downloadItem = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2
});

const listHolder = css({
    padding: 0,
    margin: 0,
    listStyle: "none"
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

import {ArticleAttachmentModalButton} from "./ArticleAttachmentModalButton";

interface IProps {
    article: {
        attachments: {
            file: string;
            title: string;
            id: number;
        }[];
    };
}

export const ArticleAttachment: React.FC<IProps> = (props) => {
    return props.article.attachments.length > 0 ? (
        <div className={articleAttachment}>
            <Text variant="headline_4" as="div" fontFamily="secondary">
                Załącznik do pobrania
            </Text>

            <ul className={listHolder}>
                {props.article.attachments.map(({id, title, file}) => {
                    return (
                        <li key={id} className={downloadItem}>
                            <ArticleAttachmentModalButton attachmentId={id} attachmentLink={file} title={title} />
                        </li>
                    );
                })}
            </ul>
        </div>
    ) : null;
};

const articleAttachment = css({
    p: 4,
    borderRadius: 2,
    mb: 2,
    backgroundColor: "white"
});

const downloadItem = css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2
});

const listHolder = css({
    padding: 0,
    margin: 0,
    listStyle: "none"
});
